module.exports = __webpack_public_path__ + "img/Icon-3-06.d7a07bc2.png";